<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  id="sidebar"
  class="dark bg-black-900 print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.default"
  [opened]="!isScreenSmall">
  <ng-container class="mb-3" fuseVerticalNavigationContentHeader>
    <div class="flex h-30 items-center justify-center p-6 pb-3 mb-14 mt-7">
      <a routerLink="/dashboard">
        <img class="w-80 dark:hidden" src="{{ portalLogo }}" alt="Logo image" />
        <img
          class="hidden w-80 dark:flex"
          src="{{ portalLogoWhite }}"
          alt="Logo image" />
      </a>
    </div>

    @if (!status) {
      <div
        class="absolute inset-x-0 bottom-0 mx-auto w-full text-center"
        style="max-width: 95%; margin-left: auto; margin-right: auto">
        <div
          class="flex flex-col items-center justify-center px-4 py-2 bg-yellow-100 border-4 border-yellow-500 text-yellow-800 rounded-lg">
          <!-- Icon at the beginning of the text -->
          <mat-icon
            [svgIcon]="'heroicons_outline:exclamation-triangle'"
            class="mr-2 text-yellow-800 flex-shrink-0"></mat-icon>
          <div class="flex items-center text-left w-full">
            <!-- Text wraps around the icon -->
            <p class="flex-1">
              {{ 'layout.classic.verifyEmailNotice' | transloco }}
            </p>
          </div>
          <!-- Button at the bottom -->
          <button
            class="mt-4 px-2 py-1 bg-yellow-500 text-white rounded hover:bg-yellow-600 w-full"
            (click)="resendVerificationEmail()">
            {{ 'layout.classic.resendEmail' | transloco }}
          </button>
        </div>
      </div>
    }
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex min-h-screen w-full min-w-0 flex-col">
  <!-- Header -->
  <div
    class="ios-safe-header bg-card relative z-49 flex w-full flex-0 items-center gap-2 px-3 shadow dark:border-b dark:bg-transparent dark:shadow-none sm:px-4 md:px-6 print:hidden">
    <!-- Navigation toggle -->
    <button
      mat-icon-button
      class="shrink-0 md:mr-2"
      (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
    </button>

    <!-- Header action buttons -->
    <div class="flex min-w-0 items-center gap-2">
      <!-- Create Quote Request -->
      <button
        class="flex h-10 shrink-0 items-center justify-center rounded-md bg-primary-600 px-3 text-white transition-colors hover:bg-primary-800 dark:bg-primary-500 dark:hover:bg-primary-600 sm:px-4"
        [matTooltip]="'layout.classic.createNewQuoteRequest' | transloco"
        (click)="navigateToCreateQuoteRequest()">
        <span class="hidden whitespace-nowrap text-sm font-bold sm:inline">
          {{ 'layout.classic.createQuoteRequest' | transloco }}
        </span>

        <mat-icon
          class="text-white sm:ml-1"
          [svgIcon]="'heroicons_outline:plus'">
        </mat-icon>
      </button>

      <button
        class="flex h-10 shrink-0 items-center justify-center rounded-md bg-primary-600 px-3 text-primary-600 transition-colors hover:bg-primary-600 hover:text-white dark:border-indigo-500 dark:bg-primary-500 dark:hover:bg-primary-600 dark:text-indigo-500 dark:hover:bg-indigo-500 sm:px-4"
        matTooltip="AI Quote Request"
        (click)="navigateToAiQuoteRequest()">
        <mat-icon
          class="md:ml-1"
          [ngClass]="'text-white'"
          [svgIcon]="'heroicons_outline:sparkles'">
        </mat-icon>

        <span
          class="hidden whitespace-nowrap text-sm text-white font-bold md:inline">
          AI Quote Request
        </span>

        <mat-icon
          class="text-white sm:ml-1"
          [svgIcon]="'heroicons_outline:plus'">
        </mat-icon>
      </button>
    </div>

    <!-- Right-side components -->
    <div class="ml-auto flex min-w-0 items-center gap-0.5 sm:gap-1 md:gap-2">
      <!-- Hide theme and language on very small screens -->
      <themeswitch class="hidden sm:block"></themeswitch>
      <languages class="hidden md:block"></languages>

      <!-- Hide search on mobile to prevent header overflow -->
      <search class="hidden lg:block" [appearance]="'bar'"></search>

      <notifications></notifications>
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <portal-impersonation-banner />
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
        Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <div
    class="bg-card relative z-49 flex h-14 w-full shrink-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden">
    <span class="text-secondary font-medium">
      <a
        [href]="companyWebsite"
        target="_blank"
        class="text-primary-600 hover:underline">
        {{ companyName }}
      </a>
      powered by
      <a
        [href]="circleWebsite"
        target="_blank"
        class="text-primary-600 hover:underline">
        Circle Bit
      </a>
    </span>
  </div>
</div>

<!-- Quick chat -->
<!-- <quick-chat #quickChat="quickChat"></quick-chat> -->
